export default {
  icon: '28px',
};
